import { createSlice } from '@reduxjs/toolkit';
import { authService } from '../../services/api';

const initialState = {
  isAuthenticated: false,
  userRole: null,
  user: null,
  userUnit: null,
  error: null,
  loading: false
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.isAuthenticated = true;
      state.userRole = action.payload.role;
      state.user = action.payload;
      
      // 處理用戶單位信息
      if (action.payload.unit) {
        state.userUnit = {
          id: action.payload.unit,
          number: action.payload.unit,
          floor: action.payload.unit.split('-')[1]?.substring(0, 2),
          isOwner: action.payload.isOwner || false
        };
      }
      
      state.loading = false;
      state.error = null;
    },
    loginFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.userRole = null;
      state.user = null;
      state.userUnit = null;
      state.error = null;
    }
  },
});

export const { loginStart, loginSuccess, loginFailure, logout } = authSlice.actions;

// 模擬登入 API 調用
export const login = (credentials) => async (dispatch) => {
  try {
    dispatch(loginStart());
    
    // 使用API服務進行登入 (生產環境)
    if (process.env.NODE_ENV === 'production') {
      let response;
      if (credentials.otp) {
        response = await authService.loginWithOtp(credentials);
      } else {
        response = await authService.login(credentials);
      }
      dispatch(loginSuccess(response.user));
      return { success: true };
    } 
    
    // 開發環境使用模擬資料
    // 模擬API請求延遲
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    // 模擬用戶驗證邏輯
    if (credentials.username === 'admin' && credentials.password === 'admin123') {
      const userData = {
        id: 'admin1',
        name: '管理員',
        role: 'manager',
        email: 'admin@example.com',
        avatar: null
      };
      dispatch(loginSuccess(userData));
      return { success: true };
    } else if (credentials.username === 'resident' && credentials.password === 'resident123') {
      const userData = {
        id: 'res1',
        name: '陳小明',
        role: 'resident',
        unit: 'A-1201',
        email: 'resident@example.com',
        avatar: null,
        isOwner: true
      };
      dispatch(loginSuccess(userData));
      return { success: true };
    } else if (credentials.username === 'tenant' && credentials.password === 'tenant123') {
      const userData = {
        id: 'ten1',
        name: '李商戶',
        role: 'tenant',
        unit: 'B-101',
        tenantName: '李氏商店',
        email: 'tenant@example.com',
        avatar: null,
        leaseStart: '2023-01-01',
        leaseEnd: '2025-12-31',
        rent: 'HK$25,000',
        nextPayment: '2023-06-01'
      };
      dispatch(loginSuccess(userData));
      return { success: true };
    } else if (credentials.username === 'security' && credentials.password === 'security123') {
      const userData = {
        id: 'sec1',
        name: '張保安',
        role: 'security',
        position: '主管',
        email: 'security@example.com',
        avatar: null
      };
      dispatch(loginSuccess(userData));
      return { success: true };
    } else if (credentials.otp && credentials.otp.length === 6) {
      const userData = {
        id: `visitor-${Date.now()}`,
        name: '訪客',
        role: 'visitor',
        accessCode: credentials.otp,
        validUntil: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString()
      };
      dispatch(loginSuccess(userData));
      return { success: true };
    } else {
      dispatch(loginFailure('用戶名或密碼錯誤'));
      return { success: false, error: '用戶名或密碼錯誤' };
    }
  } catch (error) {
    dispatch(loginFailure(error.message || '登入失敗'));
    return { success: false, error: error.message || '登入失敗' };
  }
};

// 處理登出
export const logoutUser = () => (dispatch) => {
  // 清除本地儲存的令牌
  authService.logout();
  // 更新狀態
  dispatch(logout());
};

// 檢查用戶是否已登入
export const checkAuth = () => async (dispatch) => {
  if (authService.isAuthenticated()) {
    try {
      // 獲取用戶信息
      const userData = await authService.getCurrentUser();
      dispatch(loginSuccess(userData));
    } catch (error) {
      // 如果獲取用戶信息失敗，登出用戶
      authService.logout();
      dispatch(logout());
    }
  }
};

export default authSlice.reducer; 